
import { Link } from 'react-router-dom';

export default function Information() {
  const officialLinks = [
    {
      title: '厚生労働省',
      description: '医薬品・医療機器等の安全性情報、薬事行政の最新情報',
      url: 'https://www.mhlw.go.jp/',
      icon: 'ri-government-line',
      color: 'bg-blue-50 text-blue-600',
      sections: [
        '医薬品・医療機器等安全性情報',
        '薬事・食品衛生審議会',
        '医薬品医療機器総合機構（PMDA）',
        '薬剤師国家試験情報'
      ]
    },
    {
      title: 'PMDA（医薬品医療機器総合機構）',
      description: '医薬品・医療機器の安全対策、副作用情報、添付文書情報',
      url: 'https://www.pmda.go.jp/',
      icon: 'ri-shield-check-line',
      color: 'bg-red-50 text-red-600',
      sections: [
        '医薬品・医療機器等安全性情報',
        '副作用情報',
        '添付文書情報',
        '安全対策情報'
      ]
    },
    {
      title: '日本薬剤師会',
      description: '薬剤師の職能向上、薬局業務の標準化、研修情報',
      url: 'https://www.nichiyaku.or.jp/',
      icon: 'ri-user-star-line',
      color: 'bg-green-50 text-green-600',
      sections: [
        '薬剤師研修情報',
        '薬局業務指針',
        '学術情報',
        '政策提言'
      ]
    }
  ];

  const academicSocieties = [
    {
      title: '日本病院薬剤師会',
      description: '病院薬剤師の専門性向上と医療安全',
      url: 'https://www.jshp.or.jp/',
      icon: 'ri-hospital-line'
    },
    {
      title: '日本薬学会',
      description: '薬学研究の発展と薬学教育の向上',
      url: 'https://www.pharm.or.jp/',
      icon: 'ri-flask-line'
    },
    {
      title: '日本医療薬学会',
      description: '医療薬学の発展と薬物療法の最適化',
      url: 'https://www.jsphcs.jp/',
      icon: 'ri-medicine-bottle-line'
    },
    {
      title: '日本薬剤疫学会',
      description: '薬剤疫学研究と医薬品の適正使用',
      url: 'https://www.jspe.jp/',
      icon: 'ri-line-chart-line'
    },
    {
      title: '日本臨床薬理学会',
      description: '臨床薬理学の発展と薬物療法の科学的根拠',
      url: 'https://www.jscpt.jp/',
      icon: 'ri-test-tube-line'
    },
    {
      title: '日本薬物動態学会',
      description: '薬物動態学の研究と個別化医療の推進',
      url: 'https://www.jssx.org/',
      icon: 'ri-pulse-line'
    }
  ];

  const diseaseGuidelines = [
    {
      category: '循環器疾患',
      guidelines: [
        { name: '高血圧治療ガイドライン', organization: '日本高血圧学会', url: 'https://www.jpnsh.jp/' },
        { name: '動脈硬化性疾患予防ガイドライン', organization: '日本動脈硬化学会', url: 'https://www.j-athero.org/' },
        { name: '心房細動治療ガイドライン', organization: '日本循環器学会', url: 'https://www.j-circ.or.jp/' },
        { name: '心不全治療ガイドライン', organization: '日本循環器学会', url: 'https://www.j-circ.or.jp/' }
      ],
      icon: 'ri-heart-pulse-line',
      color: 'bg-red-50 text-red-600'
    },
    {
      category: '内分泌・代謝疾患',
      guidelines: [
        { name: '糖尿病治療ガイド', organization: '日本糖尿病学会', url: 'https://www.jds.or.jp/' },
        { name: '甲状腺疾患診断ガイドライン', organization: '日本甲状腺学会', url: 'https://www.japanthyroid.jp/' },
        { name: '脂質異常症治療ガイド', organization: '日本動脈硬化学会', url: 'https://www.j-athero.org/' },
        { name: '骨粗鬆症治療ガイドライン', organization: '日本骨代謝学会', url: 'https://www.jsbmr.jp/' }
      ],
      icon: 'ri-dna-line',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      category: '呼吸器疾患',
      guidelines: [
        { name: '喘息予防・管理ガイドライン', organization: '日本アレルギー学会', url: 'https://www.jsaweb.jp/' },
        { name: 'COPD診断と治療のガイドライン', organization: '日本呼吸器学会', url: 'https://www.jrs.or.jp/' },
        { name: '肺炎診療ガイドライン', organization: '日本呼吸器学会', url: 'https://www.jrs.or.jp/' },
        { name: '間質性肺炎診断ガイドライン', organization: '日本呼吸器学会', url: 'https://www.jrs.or.jp/' }
      ],
      icon: 'ri-lungs-line',
      color: 'bg-cyan-50 text-cyan-600'
    },
    {
      category: '消化器疾患',
      guidelines: [
        { name: 'ヘリコバクター・ピロリ感染症治療ガイド', organization: '日本ヘリコバクター学会', url: 'https://www.jshr.jp/' },
        { name: '炎症性腸疾患治療ガイドライン', organization: '日本消化器病学会', url: 'https://www.jsge.or.jp/' },
        { name: '肝炎治療ガイドライン', organization: '日本肝臓学会', url: 'https://www.jsh.or.jp/' },
        { name: '胃食道逆流症治療ガイドライン', organization: '日本消化器病学会', url: 'https://www.jsge.or.jp/' }
      ],
      icon: 'ri-stomach-line',
      color: 'bg-green-50 text-green-600'
    },
    {
      category: '精神・神経疾患',
      guidelines: [
        { name: 'うつ病治療ガイドライン', organization: '日本うつ病学会', url: 'https://www.secretariat.ne.jp/jsmd/' },
        { name: '統合失調症治療ガイドライン', organization: '日本神経精神薬理学会', url: 'https://www.jsnp.org/' },
        { name: 'パーキンソン病治療ガイドライン', organization: '日本神経学会', url: 'https://www.neurology-jp.org/' },
        { name: 'てんかん治療ガイドライン', organization: '日本てんかん学会', url: 'https://www.jepilepsysociety.jp/' }
      ],
      icon: 'ri-brain-line',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      category: 'がん',
      guidelines: [
        { name: 'がん薬物療法ガイドライン', organization: '日本癌治療学会', url: 'https://www.jsco.or.jp/' },
        { name: '乳癌診療ガイドライン', organization: '日本乳癌学会', url: 'https://jbcs.xsrv.jp/' },
        { name: '肺癌診療ガイドライン', organization: '日本肺癌学会', url: 'https://www.haigan.gr.jp/' },
        { name: '大腸癌治療ガイドライン', organization: '大腸癌研究会', url: 'https://www.jsccr.jp/' }
      ],
      icon: 'ri-shield-cross-line',
      color: 'bg-orange-50 text-orange-600'
    }
  ];

  const additionalResources = [
    {
      title: '医薬品情報データベース',
      description: '添付文書、インタビューフォーム、安全性情報',
      icon: 'ri-database-line',
      links: [
        { name: 'PMDA添付文書検索', url: 'https://www.pmda.go.jp/' },
        { name: '医薬品医療機器情報提供ホームページ', url: 'https://www.pmda.go.jp/' }
      ]
    },
    {
      title: '薬物相互作用情報',
      description: '薬物間相互作用、食品との相互作用情報',
      icon: 'ri-links-line',
      links: [
        { name: '相互作用チェッカー', url: '#' },
        { name: '薬物相互作用データベース', url: '#' }
      ]
    },
    {
      title: '副作用情報',
      description: '副作用報告、安全性情報、注意喚起',
      icon: 'ri-alert-line',
      links: [
        { name: 'PMDA副作用情報', url: 'https://www.pmda.go.jp/' },
        { name: '医薬品安全性情報', url: 'https://www.pmda.go.jp/' }
      ]
    },
    {
      title: '薬価情報',
      description: '薬価基準、薬価改定情報',
      icon: 'ri-money-yen-circle-line',
      links: [
        { name: '薬価基準収載品目リスト', url: 'https://www.mhlw.go.jp/' },
        { name: '薬価改定情報', url: 'https://www.mhlw.go.jp/' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-indigo-50 to-purple-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/f3974b94db8b950806faf5c0d74548d1.jpg"
            alt="医療情報リソース"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            医療<span className="text-teal-600">情報提供</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            公的機関リンク、疾患ガイドライン、学会情報など、薬剤師に必要な情報を集約
          </p>
        </div>
      </section>

      {/* Official Links Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">公的機関リンク</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {officialLinks.map((link, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100">
                <div className={`w-16 h-16 rounded-xl ${link.color} flex items-center justify-center mb-6`}>
                  <i className={`${link.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{link.title}</h3>
                <p className="text-gray-600 mb-6">{link.description}</p>
                <ul className="space-y-2 mb-6">
                  {link.sections.map((section, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      {section}
                    </li>
                  ))}
                </ul>
                <a 
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 cursor-pointer"
                >
                  サイトを開く
                  <i className="ri-external-link-line ml-2"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Academic Societies Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">学会関連リンク</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {academicSocieties.map((society, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 border border-gray-100">
                <div className="w-12 h-12 bg-teal-50 text-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${society.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{society.title}</h3>
                <p className="text-gray-600 mb-4">{society.description}</p>
                <a 
                  href={society.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-600 font-medium hover:text-teal-700 cursor-pointer"
                >
                  詳細を見る →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Disease Guidelines Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">疾患ガイドライン</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {diseaseGuidelines.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6 border border-gray-100">
                <div className={`w-12 h-12 rounded-lg ${category.color} flex items-center justify-center mb-4`}>
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{category.category}</h3>
                <ul className="space-y-3">
                  {category.guidelines.map((guideline, idx) => (
                    <li key={idx} className="border-l-2 border-teal-200 pl-3">
                      <div className="font-medium text-gray-900">
                        <a 
                          href={guideline.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-teal-600 cursor-pointer"
                        >
                          {guideline.name}
                        </a>
                      </div>
                      <div className="text-sm text-gray-600">{guideline.organization}</div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Resources Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">その他の情報リソース</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalResources.map((resource, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 border border-gray-100">
                <div className="w-12 h-12 bg-teal-50 text-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${resource.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{resource.title}</h3>
                <p className="text-gray-600 mb-4">{resource.description}</p>
                <ul className="space-y-2">
                  {resource.links.map((link, idx) => (
                    <li key={idx}>
                      <a 
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-teal-600 text-sm hover:text-teal-700 cursor-pointer"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">公的機関</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="https://www.mhlw.go.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">厚生労働省</a></li>
                <li><a href="https://www.pmda.go.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">PMDA</a></li>
                <li><a href="https://www.nichiyaku.or.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">日本薬剤師会</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">学会情報</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="https://www.jshp.or.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">日本病院薬剤師会</a></li>
                <li><a href="https://www.pharm.or.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">日本薬学会</a></li>
                <li><a href="https://www.jsphcs.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">日本医療薬学会</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">その他</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
